const contentScrollerSlider = new Swiper('.block-content-scroller .content-scroller-slider', {
	slidesPerView: 1,
	slidesPerGroup: 1,
	spaceBetween: 20,
	allowTouchMove: false,
	effect: 'fade',
	fadeEffect: {
		crossFade: true,
	},
});

const observeSlider = (slider: any) => {
	if (slider && slider.el) {
		const contentScrollerSliderIndex: { [key: string]: number } = {};
		slider.slides.forEach((item: any, index: number) => {
			const blockID = item.getAttribute('data-block-id') as string;
			contentScrollerSliderIndex[blockID] = index;
		});

		const observerCallback = (entries: Array<IntersectionObserverEntry>) => {
			entries.forEach((entry: IntersectionObserverEntry) => {
				if (entry.isIntersecting) {
					slider.slideTo(contentScrollerSliderIndex[entry.target.id]);
				}
			});
		};

		const observer = new IntersectionObserver(observerCallback, {
			rootMargin: '-50% 0px -50% 0px',
			threshold: 0,
		});

		const silderItems: NodeListOf<HTMLElement> | undefined =
			slider?.el && typeof slider.el.closest === 'function'
				? slider.el
						.closest('.block-content-scroller')
						?.querySelectorAll('.block-content-scroll-item')
				: undefined;

		if (silderItems) {
			silderItems.forEach((scroller: HTMLElement) => {
				if (scroller) {
					observer.observe(scroller);

					// Manually trigger the callback if it's already in view
					const rect = scroller.getBoundingClientRect();
					if (rect.top < window.innerHeight && rect.bottom > 0) {
						slider.slideTo(contentScrollerSliderIndex[scroller.id]);
					}
				}
			});
		}
	}
};

if (contentScrollerSlider) {
	if (Array.isArray(contentScrollerSlider)) {
		contentScrollerSlider.forEach((slider: any) => {
			observeSlider(slider);
		});
	} else {
		observeSlider(contentScrollerSlider);
	}
}
